import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { toggleSignInModal } from '../../actions/auth';
import { selectPromoCodeError } from '../../slices/promoCode';

export function useOpenModalOnUnauthorizedPromoCodeAttempt() {
  const error = useSelector(selectPromoCodeError);
  useEffect(() => {
    if (error === 'ERROR_UNAUTHORIZED') {
      toggleSignInModal(true, 'SIGN_IN');
    }
  }, [error]);
}
